import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'ghost' | 'link' | 'premium' | 'outline-light' | 'white';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  href?: string;
  target?: string;
  rel?: string;
}
export function Button({
  className = '',
  variant = 'default',
  size = 'default',
  href,
  target,
  rel,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'group inline-flex items-center justify-center rounded-lg text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-95';
  const variants = {
    default: 'bg-blue-600 text-white hover:bg-blue-700 shadow-md shadow-blue-500/20',
    secondary: 'bg-slate-100 text-slate-900 hover:bg-slate-200 border border-slate-200 dark:bg-slate-800 dark:text-white dark:border-slate-700 dark:hover:bg-slate-700',
    outline: 'border-2 border-slate-300 bg-white text-slate-900 hover:bg-blue-50 hover:text-blue-700 hover:border-blue-400 shadow-sm dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 dark:hover:bg-slate-700 dark:hover:text-white dark:hover:border-slate-500',
    'outline-light': 'border-2 border-white/40 bg-transparent text-white hover:bg-white/10 hover:border-white/60',
    ghost: 'text-slate-700 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white',
    link: 'text-blue-600 underline-offset-4 hover:underline dark:text-blue-400',
    premium: 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50',
    white: 'bg-white text-blue-600 hover:bg-slate-100 shadow-lg font-semibold'
  };
  const sizes = {
    default: 'h-10 px-5 py-2',
    sm: 'h-9 rounded-md px-3',
    lg: 'h-12 rounded-xl px-8 text-base',
    icon: 'h-10 w-10'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel || (target === '_blank' ? 'noopener noreferrer' : undefined)} className={classes} data-id="element-298">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-299">
      {children}
    </button>;
}